import { Linkable } from '@/components/blocks/Linkable';
import { Img } from '@/components/blocks/MaterialImage';
import { EventsContext } from '@/data/context/events';
import { useSettings } from '@/data/Settings';
import { Grid } from '@mui/material';
import { useContext } from 'react';

interface DpGridTendenceHyperProps {
	children: React.ReactNode;
}

export const DpGridTendenceHyper: React.FC<DpGridTendenceHyperProps> = ({ children, ...props }) => (
	<Grid item xs={12} md={6} container spacing="20px" {...props}>
		{children}
	</Grid>
);

export const DpCardTendenceHyper = ({
	image,
	href,
	alt,
	loading,
	priority,
	index,
	...props
}: {
	image: string;
	href?: string;
	alt?: string;
	loading?: 'lazy' | 'eager';
	priority?: boolean;
	index?: number;
}) => {
	const { onBannerClick } = useContext(EventsContext);
	const { settings } = useSettings();

	const handleClick = () => {
		onBannerClick({
			gtm: {
				banner_name: alt ?? '',
				banner_url: href ?? '',
				banner_position: index ?? 0,
				settings,
			},
		});
	};

	return (
		<Grid item xs={6} {...props}>
			<Linkable href={href} onClick={handleClick}>
				<Img
					src={image}
					alt={alt ?? ''}
					sx={{
						width: '100%',
						objectFit: 'cover',
						height: '100%',
					}}
					loading={loading}
					priority={priority}
				/>
			</Linkable>
		</Grid>
	);
};
